/*
	 * 组织机构的 新建、编辑、详情组件 
	 * 描述：
	 * 创建时间：2017-03-22 
	 * 创建人：Shujuan Sun 
	 * 修改时间：2017-3-31
*/
<template>
	<div class="float-e-margins grey_box ibox_main" id="subPage" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal ">
			<div class="form-group text-left">
				<label class="col-sm-6  control-label t_left">企业参数设定</label>
			</div>
		</div>
		<div class="form-horizontal ibox-content">
			<br />
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*组织机构名称</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.orgName.$error }">
					<input type="text" class="form-control " v-model.trim="orgName" @input="$v.orgName.$touch()" maxlength="100">
					<span class="cus_message form-group__message" v-if="!$v.orgName.required && $v.orgName.$error">组织机构名称为必填项</span>
				</div>
				<label class="col-sm-1 control-label focus_color">*英文简称</label>
				<div  class="col-sm-3" v-bind:class="{ 'form-group--error': $v.shortName.$error }" >
					<input type="text" class="form-control" v-model.trim="shortName"  @input="$v.shortName.$touch()">
					<span class="form-group__message cus_message" v-if="!$v.shortName.required && $v.shortName.$error">必填</span>
					<span class="form-group__message cus_message" v-if="!$v.shortName.isEngChar">只能包含英文字母,数字,下划线,中划线和小数点,长度在2~20之间</span>
				</div>
				<!--<label class="col-sm-1 control-label focus_color">机构状态</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.orgStatus.$error }">
					<select class="form-control" v-model.trim="orgStatus" @input="$v.orgStatus.$touch()">
						<option v-for="(item, index) in orgStatusInfo" v-bind:value="item.value">{{ item.name }}</option>
					</select>
					<span class="cus_message form-group__message" v-if="!$v.orgStatus.required && $v.orgStatus.$error">机构状态为必填项</span>
				</div>-->
				<label class="col-sm-1 control-label">机构管理方</label>
				<div v-if="isAdmin!=9 ||curMode!='new' " class="col-sm-3" >
					<input type="text" class="form-control" v-model="curParentName" readonly>
				</div>
				<div v-if="isAdmin==9 && curMode=='new'" class="col-sm-3">
					<select2 :options="superAdminCustomerList" v-model="selectCustomerId"></select2>
					<!--<select class="form-control" v-model="selectCustomerId">
						<option v-for="option in superAdminCustomerList" v-bind:value="option.id">
							{{ option.name }}
						</option>
					</select>-->
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label focus_color">*顺序号</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.orderNo.$error }">	
					<input type="text" class="form-control" v-model.trim="orderNo" @input="$v.orderNo.$touch()">
					<span class="form-group__message cus_message" v-if="!$v.orderNo.required && $v.orderNo.$error">顺序号为必填项</span>
				</div>
				<span class="col-sm-8 control-label gray t_left">建议以10为间隔设置组织机构的顺序号。如10、20、30等。</span>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">联系人</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="orgPerson" maxlength="10">
				</div>
				<label class="col-sm-1 control-label">联系电话</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="orgTel" maxlength="11">
				</div>
				<!--管理员（超管或普管）且非救援公司才可查看和编辑-->
				<label class="col-sm-1 control-label" v-if="isAdmin!=0 && levv != 3">派单权重</label> 
				<div class="col-sm-3" v-if="isAdmin!=0 && levv != 3">
					<input type="text" class="form-control" v-model="authRatio"/> 
					<p class="red help-block" v-if="!rightRatio">请输入0-100的整数</p>
				</div> 
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">组织机构地址</label>
				<div class="col-sm-11">
					<input type="text" class="form-control" v-model="orgAdd" maxlength="250">
				</div>
			</div>
			<div class="form-group mt10px" v-if="curMode == 'new'">
				<label class="col-sm-1 control-label focus_color">*管理员帐号</label>
				<div class="col-sm-3" v-bind:class="{'form-group--error': $v.account.$error }">
					<div class="input-group">
						<input type="text" class="form-control" v-model.trim="account" @input="$v.account.$touch()" >
						<div class="input-group-addon">{{shortName?'@':''}}{{shortName}}</div>
					</div>
					<span class="cus_message form-group__message" v-if="!$v.account.required && $v.account.$error">必填</span>
				</div>
				<span class="col-sm-8 control-label gray t_left">管理员登录时，使用“管理员账号”+@+“机构英文简称”作为登录名称。</span>
			</div>
			<div class="form-group mt10px" v-if="curMode == 'new'">
				<label class="col-sm-1 control-label"><span class="red">*密码</span></label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.password.$error }" style="position: relative;">
					<input type="password" class="form-control" v-model.trim="password" @input="$v.password.$touch()">
					<span class="form-group__message cus_message" v-if="!$v.password.required && $v.password.$error">必填</span>
					<span class="form-group__message cus_message" v-if="!$v.password.maxLength || !$v.password.minLength">长度在6~30之间</span>
				</div>
				<label class="col-sm-1 control-label"><span class="red">*再次输入密码</span></label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.passwordConfirm.$error }" style="position: relative;">
					<input type="password" class="form-control" v-model.trim="passwordConfirm" @input="$v.passwordConfirm.$touch()">
					<span class="form-group__message cus_message" v-if="!$v.passwordConfirm.sameAsPassword && $v.passwordConfirm.$error">两次密码不一致</span>
				</div>
			</div>
			<div class="form-group">
				<!-- <div class="col-sm-4"> -->
					<label class="col-sm-1 control-label"><span class="red">*平台挂车最大数</span></label>
					<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.maxNum.$error }">
						<!--新建时：-->
						<input type="text" class="form-control" v-model.trim="maxNum" @input="$v.maxNum.$touch()" v-if="curMode=='new'" maxlength="6">
						<!--详情时：-->
						<input type="text" class="form-control" v-model.trim="maxNum" @input="$v.maxNum.$touch()" readonly v-if="curMode=='detail'">
						<!--编辑时：超级管理员、普通管理员或操作员只允许修改其下级，不能修改自己的值-->
						<input type="text" class="form-control" v-model.trim="maxNum" @input="$v.maxNum.$touch()" :readonly="orgInfo.customerId==curCustomerId" v-if="curMode=='edit'">					
						<!--超级管理员新建一级机构时，无最大数限制-->
						<p class="help-block" v-if="curMode == 'new' && isAdmin == 9 && selectCustomerId == 1">最小值为:0</p>
						<!--普通管理员或操作员新建一级机构时，无最大数限制-->
						<p class="help-block" v-if="curMode == 'new' && isAdmin != 9 && curParentId == 1">最小值为:0</p>
						<!--超级管理员、普通管理员或操作员编辑一级机构时，无最大数限制，有最小数-->
						<p class="help-block" v-if="curMode == 'edit' && curParentId == 1">最小值为:{{carMinMount}}</p> 
						<!--超级管理员新建分支时，有最大数限制-->
						<p class="help-block" v-if="curMode =='new' && isAdmin == 9 && selectCustomerId != 1">设置范围：0-{{carMaxMount}}</p> 
						<!--超级管理员编辑除自己以外的分支时，有最小和最大数限制-->
						<p class="help-block" v-if="curMode=='edit' && isAdmin == 9 && curParentId != 1 && orgInfo.customerId != curCustomerId">设置范围：{{carMinMount}}-{{carMaxMount}}</p> 
						<!--普通管理员或操作员新建分支机构时，有最大数限制-->
						<p class="help-block" v-if="curMode=='new' && isAdmin != 9 && curParentId != 1">设置范围：0-{{carMaxMount}}</p> 
						<!--普通管理员或操作员编辑除自己以外的分支机构时，有最小和最大数限制-->
						<p class="help-block" v-if="curMode=='edit' && isAdmin != 9 && curParentId != 1 && orgInfo.customerId != curCustomerId">设置范围：{{carMinMount}}-{{carMaxMount}}</p> 
						
						<span class="form-group__message cus_message" v-if="!$v.maxNum.required && $v.maxNum.$error">必填</span>
						<span class="form-group__message cus_message" v-if="!$v.maxNum.numForm">请输入大于等于0的数字</span> 
						<span class="form-group__message cus_message" v-if="!correctNum">不要超出平台挂车范围</span>
					</div>
				<!-- </div> -->
				<div class="col-sm-2 pt10px">
					 <div class="col-sm-12" style="margin-left: 25px;">
                	     <checkbox v-model="isShowTest">是否显示测试车辆</checkbox>
                     </div>
				</div>
				<div class="col-sm-2 pt10px" v-if="isAdmin!=0 && levv != 3">
					 <div class="col-sm-12" style="margin-left: 25px;">
                	     <checkbox v-model="isMultiSent">是否允许“一车多单”</checkbox>
                     </div>
				</div>
                <div class="col-sm-3 pt10px" v-if="(isAdmin==1||isAdmin==9)&&groupId == 1">
					 <div class="col-sm-12" style="margin-left: 25px;">
                	     <checkbox v-model="serviceFlag">是否关闭接单权限</checkbox>
                     </div>
				</div>
			</div> 
			<div class="form-group" v-if="levv==1">
				<label class="col-sm-1 control-label focus_color">车辆树显示1</label>
				<div class="col-sm-3">
					<select type="text" class="form-control" v-model="tree1">
						<option v-for="tree in tempList1" :value="tree.udccode" >{{tree.udcname}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">车辆树显示2</label>
				<div class="col-sm-3">
					<select type="text" class="form-control" v-model="tree2">
						<option v-for="tree in tempList2" :value="tree.udccode" >{{tree.udcname}}</option>
					</select>
				</div>
				<label class="col-sm-1 control-label">车辆树显示3</label>
				<div class="col-sm-3">
					<select type="text" class="form-control" v-model="tree3">
						<option v-for="tree in tempList3" :value="tree.udccode" >{{tree.udcname}}</option>
					</select>
				</div>
			</div>	 
			<!--新建、编辑组织机构时-->
			<div class="form-group" v-if="curMode!=='detail'"> 
				<!--超级管理员新建一级-->
				<div v-if="isAdmin==9 && selectCustomerId==1 && curMode == 'new'">
					<label class="col-sm-1 control-label red" v-if="versionArr.length != 0">授权版本</label> 
					<div class="col-sm-3" v-if="versionArr.length != 0"> 
						<select type="text" class="form-control"  v-model.trim="licenceId" @change="$v.licenceId.$touch()">
							<option v-for="version in versionArr" :value="version.udccode">{{version.udcname}}</option>
						</select> 
						<span class="form-group__message cus_message" v-if="!$v.licenceId.required && $v.licenceId.$error">授权版本为必填项</span>
					</div>
				</div>
				<!--普通管理员或操作员新建一级-->
				<div v-if="curMode == 'new' && isAdmin != 9 && curParentId == 1">
					<label class="col-sm-1 control-label red" v-if="versionArr.length != 0">授权版本</label> 
					<div class="col-sm-3" v-if="versionArr.length != 0"> 
						<select type="text" class="form-control"  v-model.trim="licenceId" @change="$v.licenceId.$touch()">
							<option v-for="version in versionArr" :value="version.udccode">{{version.udcname}}</option>
						</select> 
						<span class="form-group__message cus_message" v-if="!$v.licenceId.required && $v.licenceId.$error">授权版本为必填项</span>
					</div>
				</div>
				<!--超级管理员、普通管理员或操作员编辑一级组织机构，只能显示，不能修改-->
				<div v-if="curMode == 'edit' && curParentId == 1">
					<label class="col-sm-1 control-label red">授权版本</label> 
					<div class="col-sm-3">  
						<select type="text" class="form-control"  v-model="licenceId" disabled>
							<option v-for="version in versionArr" :value="version.udccode">{{version.udcname}}</option>
						</select>
					</div>
				</div>
				<!--超级管理员新建分支-->
				<div v-if="isAdmin == 9 && curMode == 'new' && selectCustomerId !=1">
					<label class="col-sm-1 control-label">功能设置</label>  
					<div class="col-sm-5" v-show="funcList.length > 0" style="margin-top:0; width:250px; height: 300px; overflow:auto;">					 
						<ul id="orgFuncTreeSet" class="ztree ztree-slide"></ul>
					</div>
				</div>
				<!--普通管理员或操作员新建分支-->
				<div v-if="isAdmin != 9 && curMode == 'new' && curParentId !=1">
					<label class="col-sm-1 control-label">功能设置</label>  
					<div class="col-sm-5" v-show="funcList.length > 0" style="margin-top:0; width:250px; height: 300px; overflow:auto;">
						<ul id="orgFuncTreeSet" class="ztree ztree-slide"></ul>
					</div>
				</div>
				<!--超级管理员、普通管理员或操作员编辑除自己以外的分支-->
				<div v-if="curMode == 'edit' && curParentId !=1 && curCustomerId != orgInfo.customerId">
					<label class="col-sm-1 control-label">功能设置</label>  
					<div class="col-sm-5" v-show="funcList.length > 0" style="margin-top:0; width:250px; height: 300px; overflow:auto;">
						<ul id="orgFuncTreeSet" class="ztree ztree-slide"></ul>
					</div>
				</div> 
			</div> 
			<!--<div class="form-group mt10px" v-if="curMode != 'detail'">
				<span class="col-sm-offset-1 red" v-if="normalMail && $v.orgMail.email && $v.orgMail.required">为确保您能正常接收邮件，请将邮箱（ op_support@didi-gps.com）加入您的邮箱白名单</span>
				<a class="col-sm-offset-1 red" v-if="!normalMail && $v.orgMail.email && $v.orgMail.required" :href="mailLink" target="_blank" style="text-decoration: underline;">为确保您能正常接收邮件，请点击将邮箱（ op_support@didi-gps.com）加入白名单</a>
			</div>-->
		</div> 
		<div class="form-horizontal mt20px">
			<div class="form-group text-left">
				<label class="col-sm-1  control-label">企业LOGO</label>
				<div class="col-sm-11">
					<div class="uploadedImg t_left col-sm-3" >
						<img v-if="logoSrc == ''" key="noLogo" src="../../../assets/project/images/img_bg.jpg" class="img-responsive"/>
						<img v-else key="hasLogo" :src="logoSrc" class="img-responsive"/>
					</div>
					<vue-core-image-upload
							extensions="png,gif,jpeg,jpg"
							input-accept="image/jpg,image/jpeg,image/png"
							v-bind:crop="false" 
							v-on:imageuploaded="imageuploaded"						
							text=""
							inputOfFile="file"
							:url="picUrl"
							:headers="{'access-token':this.accesstoken}"
							v-bind:class="['upload-pic']"
							>
					</vue-core-image-upload>
					<span class="col-sm-7 control-label gray t_left">请上传jpg、jpeg或png格式的图片</span>
				</div> 
			</div>
		</div> 
		<div class="form-horizontal mt20px">
			<div class="form-group">
				<label class="col-sm-1 text-right control-label">备注</label>
				<div class="col-sm-11">
					<textarea class="form-control" rows="1" v-model="note"></textarea>
				</div>
			</div>
		</div>
		<div class="form-horizontal mt20px" style="position:relative;bottom:0;">
			<div class="hr-line-dashed"></div>
			<br />
			<div class="form-group" id="hideWhenNew">
				<label class="col-sm-1 control-label">创建人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" readonly v-model="createPerson">
				</div>
				<label class="col-sm-1 control-label">创建时间</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" readonly v-model="createTime">
				</div>
				<label class="col-sm-1 control-label">修改人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control change" v-model="changePerson">
				</div>
				<label class="col-sm-1 control-label">修改时间</label>
				<div class="col-sm-2">
					<input type="text" class="form-control change" v-model="changeTime">
				</div>
			</div>
			<div class="form-group">
				<button  class="btn btn-primary col-sm-offset-5" @click="onSave" :disabled="!isDisable || !rightRatio" v-text="btnValue"></button>
			</div>
		</div>
		<!--SubPage组件弹框开始-->
			<sub-modal ref="modal2" size="small" title="温馨提示">
						<p v-text="tipContent"></p>	
						<div slot="footer">
							<button v-if="showWithdraw" class="btn btn-primary" @click="withdrawSubBtn">取消</button>
							<button class="btn btn-primary" @click="confirmSubBtn">确定</button>
						</div>
			</sub-modal>
		<!--SubPage组件弹框结束-->
		<!--功能权限树弹框-->
		<!--<sub-modal ref="modal3" size="small" title="设置功能权限树">
				<div></div>
				<div slot="footer">
					<button v-if="showWithdraw" class="btn btn-primary" @click="stopSetting">取消</button>
					<button class="btn btn-primary" @click="confirmSetting">确定</button>
				</div>
			</sub-modal>-->
	</div>
</template>
<script>
	import VueCoreImageUpload from 'vue-core-image-upload'
	import {required,email,sameAs,minLength, maxLength} from 'vuelidate/lib/validators'
	import SubModal from 'components/common/SubModal'
	import { GET_FAILE,OPERATE_EXCEPTION,OPERATE_SUCCESS,ADD_ENSURE,EDIT_ENSURE,INFO_EXCEPTION } from 'static/message'
	import {INFO_STATUS} from 'static/constant'
	import Checkbox from 'components/common/Checkbox'
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'	
	import Select2 from 'components/common/Select2'
	export default {
		name: 'PageOrganiseEdit',
		components: {
		   VueCoreImageUpload,
		   Checkbox,
		   SubModal,
		   Select2
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["organiseList"]?this.$store.state.permission.permission["organiseList"]:[],
				loadingstatus:false,
				contUrl:'/system/udcs',
				postUrl:'/account/customers',//post url --createNew
				putUrl:'/account/customers',//put url--edit
				param:{},		  // 新建或编辑时传给后台的接口参数
				// 以下为表单输入内容
				orgDetailInfo:{},
				isAdmin:0,
				orgName:'',	
				orgStatus:'1',
				orgStatusInfo:INFO_STATUS,
				orderNo:'',
				orgPerson:'',
				orgTel:'',
				orgAdd:'',
				orgMail:'',
				maxNum:'',
				showContList1:[],
				tree1:'CUSTOMER_NAME',
				tree2:'OWNER_NAME',
				tree3:'OWNER_PHONE',
				note:'',
				logoSrc:'',
				logoImg:'', 
				createPerson:'',
				createTime:'',
				changePerson:'',
				changeTime:'',
				isShowTest:false,          //是否显示测试车
				//表单输入内容结束
				btnValue:'保存',			//编辑、新建是保存，查看是关闭
				showWithdraw:false,		//弹框显示取消按钮否
				tipContent:'',			//弹框提示内容
				timeToBack:false,		//是否关闭subpage组件并返回一览页面
				toRefresh:false,			//是否开始刷新页面---initTable
				superAdminCustomerList:[],    //超级管理员时下拉
				selectCustomerId:'1',           //超级管理员时选择的组织机构id
				picUrl:process.env.API_ROOT +"/account/customers/logo",
				mailLink:'',            //根据邮箱类型给出不同跳转链接
				normalMail:false,        //是否是非163  sina qq邮箱以外的邮箱
				shortName: "",		//英文简称
				password: "",			// 密码
				passwordConfirm: "",
				account: "",
				tempList1:[],
				tempList2:[],
				tempList3:[],
				//授权版本信息
				carMaxMount:'', //最大挂车数
				carMinMount:'', //最小挂车数
				versionArr:[],
				licenceId:'',   //新建或编辑一级组织机构时的版本id
				//功能树相关
				orgFuncTree:{},
				setting:{
					data: {
		                simpleData: {
		                    enable: true,
		                    idKey: "id",
							pIdKey: "pId"
		                }
		           },
		           check: {
		           		enable: true,
		           		chkboxType:{ "Y" : "ps", "N" : "ps" }
		           	},
		           	callback: {
		           		onCheck: null
		           	}
				},
				funcList:[], //功能树列表
				authRatio:100, //派单权重
                isMultiSent:false,//是否允许一车多单
                serviceFlag:false
			};
		},
		validations:{
			orgName:{
				required
			},
			orgStatus:{
				required
			},
			orderNo:{
				required
			},
			orgMail:{
				required,
				email
			},
			licenceId:{
				required
			},
			account:{
				required
			},
			shortName:{
				required,
				isEngChar(val){
					if(!val){
						return true;
					}
					// 只允许输入字母、数字、下划线、中划线以及小数点
					let regExp = /^[a-zA-Z0-9\_\-\.]{2,20}$/;
					return regExp.test(val);
				}
			},
			password: {
	    		required,
	    		maxLength: maxLength(30),
	    		minLength: minLength(6)
	    	},
	    	maxNum:{
	    		required,
	    		numForm(val){
	    			if(!val){
	    				return true
	    			}
	    			//只允许输入数字
	    			let reg = /^\d+$/
	    			return reg.test(val)
	    		}
	    	},
	    	passwordConfirm: {
	    		sameAsPassword: sameAs('password')
	    	},
		},
		//curMode分为：详情、编辑、新建，详情时只读/禁用表单
		props:['orgInfo','curMode','curCustomerName','curCustomerId','dispatchWeight','multiAllowable','serviceFlagSent'],
		watch:{  
			orgInfo:function(val){
//				this.setFormInfo();
			},
			tree1:function(val){
				this.correctionSelect(this)
			},
			tree2:function(val){
				this.correctionSelect(this)
			},
			tree3:function(val){
				this.correctionSelect(this)
			}, 
			showContList1(val){ 
				this.tempList1=val;
				this.tempList2=val;
				this.tempList3=val;
				this.correctionSelect(this)
			}, 
			shortName(val){
				if(val.length > 20){
					this.shortName = this.shortName.substring(0, 20);
				}
			},
			selectCustomerId(val){
				this.setFunc()
				this.getVersionInfo(val)
			}
//			orgMail:function(val){
//				let str = val.substring(val.indexOf('@'))
//				if(/(@163.com)$/.test(str) || /(@126.com)$/.test(str)){
//					this.normalMail = false
//					this.mailLink = 'http://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac28e86c6b6ec2acd66'
//					return
//				}else if(/(@sina.com)$/.test(str)){
//					this.normalMail = false
//					this.mailLink = 'http://mail.sina.com.cn/help2/2008-08-02-86.html'
//					return
//				}else if(/(@qq.com)$/.test(str)){
//					this.normalMail = false
//					this.mailLink = 'http://service.mail.qq.com/cgi-bin/help?subtype=1&no=113&id=16'
//					return
//				}else{
//					this.normalMail = true
//					this.mailLink = 'javascript(void)'
//					return
//				}
//			}
		},
		created(){
			this.isAdmin = this.$store.state.user.admin;
		},
		computed:{
			groupId(){
				return this.$store.state.user.groupid
			},
			levv(){
				return this.$store.state.user.levv
			},
			rightRatio(){
				return /^([0-9]|[1-9]\d|100)$/.test(this.authRatio)
			},
			//新建状态 超级 管理员 
			isSuperAdmin: function(){
				if(this.$store.state.user.admin==9 && this.curMode == 'new')return true;
				return false;
			},
			accesstoken:function(){
				return this.$store.state.user.accesstoken
			},
			correctNum:function(){//判断是否超出挂车范围
				//普通管理员或操作员编辑除自己以外的下级-有最大最小值
				let needCheck1 = this.isAdmin != 9 && this.curMode=='edit' && this.orgInfo.customerId != this.curCustomerId  
				//普通管理员或操作员新建分支-有最大值
				let needCheck2 = this.isAdmin != 9 && this.curMode == 'new' && this.curParentId != 1
				//超级管理员新建分支 -有最大值
				let needCheck3 = this.isAdmin == 9 && this.curMode == 'new' && this.selectCustomerId != 1 
				//超级管理员编辑除自己以外的分支-有最大最小值
				let needCheck4 = this.isAdmin == 9 && this.curMode == 'edit' && this.curParentId != 1 && this.orgInfo.customerId != this.curCustomerId 
				//超级管理员、普通管理员或操作员编辑一级-有最小值
				let needCheck5 = this.curMode == 'edit' && this.curParentId == 1
			/*	console.log(needCheck1)
				console.log(needCheck2)
				console.log(needCheck3)
				console.log(needCheck4)*/
				if(needCheck1 || needCheck2 || needCheck3 || needCheck4 || needCheck5){
					let num = Number(this.maxNum) 
					if(num != 0){
						if(/^\d+$/.test(this.maxNum)){
							if(this.curMode=='new'){
								return num <= this.carMaxMount
							}else if(this.curMode == 'edit'){
								if(needCheck5){
									return num >= this.carMinMount
								}else{
									return num <= this.carMaxMount && num >= this.carMinMount
								} 
							}
							
						}else{
							return true
						} 
					}else{
						return true
					} 
				}else{
					return true
				}
				
			}, 
			/*qqMail:function(){
				const indexAt = this.orgMail.indexOf('@');
				const indexDot = this.orgMail.indexOf('.')
				const qqStr = this.orgMail.substring(indexAt + 1,indexDot)
				if(qqStr === 'qq' || qqStr === 'QQ'){
					return false
				}else{
					return true
				}
			},*/
			isDisable:function(){
				let isPasswordOK = true;
				let versionOK = true;
				let setFuncTree = true
				if(this.curMode == 'new'){
					isPasswordOK = this.$v.account.required && this.$v.password.required &&
									this.$v.password.minLength && this.$v.password.maxLength 
									this.$v.passwordConfirm.sameAsPassword;
					//超级管理员新建二级分支--设置功能树--直接弹框返回		
					//超级管理员新建一级分支--必须选择授权版本-需要校验
					if(this.isAdmin == 9 && this.selectCustomerId == 1){
						versionOK = this.$v.licenceId.required
					}	
					//普通管理员新建一级分支
					if(this.isAdmin != 9 && this.curParentId == 1){
						versionOK = this.$v.licenceId.required
					}
				}
				 
				return this.$v.orgName.required && this.$v.orgStatus.required && 
				this.$v.shortName.required && this.$v.shortName.isEngChar &&
				this.$v.orderNo.required && isPasswordOK && this.$v.maxNum.required && versionOK && setFuncTree;
			},
			curParentName:function(){//curParentName:不同curMode下对应的机构管理方名称
				if((this.curMode==='detail' || this.curMode ==='edit') && (this.groupId != this.orgInfo.customerId)){
					return this.orgInfo.parentName
				}else if(this.curMode === 'new' && this.isAdmin != 9){
					return this.curCustomerName
				}else{//new
					return ''
				}
			},
			curParentId:function(){
				if(this.curMode==='detail' || this.curMode ==='edit'){
					return this.orgInfo.parentId
				}else if(this.curMode === 'new' && this.isAdmin != 9){
					return this.curCustomerId
				}else{//new
					return ''
				}
			}
		},
		beforeMount() { 
			this.setFormInfo();
			this.getShowCont();
			this.getCustomerTree(); 
			if(this.curMode == 'new'){
				let orgPId = ''
				if(this.isAdmin==9){ 
					orgPId = this.selectCustomerId
				}else{
					orgPId = this.curParentId  
				} 
				this.getVersionInfo(orgPId) 
			} 
			//超级管理员新建分支
			let term1 = this.isAdmin == 9 && this.curMode == 'new' && this.selectCustomerId !=1
			//普通管理员或操作员新建分支
			let term2 = this.isAdmin != 9 && this.curMode == 'new' && this.curParentId !=1
			//超级管理员、普通管理员或操作员编辑除自己以外的分支
			let term3 = this.curMode == 'edit' && this.curParentId !=1 && this.curCustomerId != this.orgInfo.customerId 
			if(term1 || term2 || term3){
				this.setFunc()
			} 
		},  
		mounted(){
			this.authRatio = this.dispatchWeight
            this.isMultiSent = this.multiAllowable === 1?true:false
            this.serviceFlag = this.serviceFlagSent == 1?true:false
		},
		methods: {
			saveRatio(){ 
				if(this.curMode=='detail') return
				this.loadingstatus = true
				let orgId;
				if(this.curMode=='new'){
					orgId = this.curCustomerId
				}else{
					orgId = this.orgInfo.customerId
				}
				return new Promise((resolve,refuse)=>{
					this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/account/customer/' + orgId,{qz:this.authRatio,isMulti:this.isMultiSent?1:2,serviceFlag:this.serviceFlag?1:0},{emulateJSON:true})
					.then((res)=>{
						this.loadingstatus = false 
						resolve()
					},(res)=>{
						this.loadingstatus = false
						this.$refs.modal2.open();
						this.showWithdraw = false; 
						if(!res.body.message){
							this.tipContent = '派单权重和一车多单设置失败'
							return
						}
						this.tipContent = res.body.message
					})
				})
				
			},
			//获取最大挂车数
			getVersionInfo(orgPId){//新建时 
				this.$http.get(process.env.API_ROOT + '/account/residueMaxMount',{params:{customerId:orgPId}})
				.then(res=>{
					let obj = res.body.data
					this.carMaxMount = obj.residuemaxMount  
					if(obj.versionMap!= null){
						this.versionArr = obj.versionMap.version
					} 
				},res=>{
					this.$refs.modal2.open();
					this.showWithdraw = false;
					this.tipContent = res.body.message
				})
			}, 
			setFunc(){//点击设置功能权限树
				//待传参数1：机构管理方id 2:当前模式 edit:编辑   create:新建
				this.loadingstatus = true
				let mode = ''
				if(this.curMode == 'new'){
					mode = 'create'
				}else if(this.curMode == 'edit'){
					mode = 'edit'
				}else{
					return
				}
				let orgPId = ''
				if(this.curMode == 'new'){ //新建二级时，设置功能树接口传机构管理方id,
					if(this.isAdmin==9){ 
						orgPId = this.selectCustomerId
					}else{
						orgPId = this.curParentId  
					} 
				}else if(this.curMode == 'edit'){//编辑二级时，设置功能树接口传被编辑的id 
					orgPId = this.orgInfo.customerId
				}else{
					return
				} 
				this.$http.get(process.env.API_ROOT + '/account/resourceIdList',{params:{customerId:orgPId,mode:mode}})
				.then(res=>{
					this.loadingstatus = false
					this.funcList = res.body.data.resourceList
					if(this.funcList.length > 0){
						// if(this.levv != 1){
						// 	this.funcList.map(node=>{
						// 		let rName = node.name
						// 		switch (rName){
						// 			case '综合监控平台':
						// 				node.name = '救援监控平台'
						// 				break;
						// 			case '车辆轨迹回放':
						// 				node.name = '救援车辆轨迹'
						// 				break;
						// 			case '车辆档案管理':
						// 				node.name = '救援车辆一览'
						// 				break;
						// 			default:
						// 				node.name = rName;
						// 				break;			
						// 		}
						// 		return node
						// 	})
						// }
						this.treeInit()
					}else{
						this.$refs.modal2.open();
						this.showWithdraw = false;
						this.tipContent =  '您好，功能树数据为空'
					} 
				},res=>{
					this.loadingstatus = false
					this.$refs.modal2.open();
					this.showWithdraw = false;
					this.tipContent = res.body.message
				})
			},
			treeInit(){//初始化z-tree树
				$.fn.zTree.init($("#orgFuncTreeSet"), this.setting, this.funcList);
				this.$nextTick(()=>{
					this.orgFuncTree = $.fn.zTree.getZTreeObj('orgFuncTreeSet');
				})
			},
			getFuncSelectedLeafNodes(){
				var result = [];
				const { orgFuncTree } = this;
				var nodes = orgFuncTree.getCheckedNodes(true);
				nodes.forEach( node => {
					result.push(node.id);
				})
		//		result.push(1);
				return result;
			},
			// 若所有的子节点已勾选，则只选择当前节点
			/*getCheckRootNodes(){
				let queue = [];
				let result = [];
				let tree = this.orgFuncTree.getNodes();
				queue.push(...tree);
				while(queue.length != 0){
					let node = queue.shift();
					let checkState = node.getCheckStatus();
					// 若全勾选，则加到result
					if(checkState.checked && !checkState.half){ 
						result.push(node.id)
					} else if (checkState.checked && checkState.half){
						// 否则，若半勾选，则加到result并把childNode加到队列中 
						result.push(node.id)
						if(node.children){
							queue.push(...node.children);
						}
					} else if (!checkState.checked){
						// 若未勾选，则把子节点加到队列中
						if(node.children){
							queue.push(...node.children);
						}
					}
				}
				console.log(result);
				return result;
			},*/
			correctionSelect(self){
				this.tempList1=this.showContList1.concat();
				this.tempList2=this.showContList1.concat();
				this.tempList3=this.showContList1.concat();
				if(self.tree1){
					this.tempList2.splice(this.tempList2.findIndex(n=>n.udccode==self.tree1),1);
					this.tempList3.splice(this.tempList3.findIndex(n=>n.udccode==self.tree1),1);
				};
				if(self.tree2){
					this.tempList1.splice(this.tempList1.findIndex(n=>n.udccode==self.tree2),1);
					this.tempList3.splice(this.tempList3.findIndex(n=>n.udccode==self.tree2),1);
				};
				if(self.tree3){
					this.tempList1.splice(this.tempList1.findIndex(n=>n.udccode==self.tree3),1);
					this.tempList2.splice(this.tempList2.findIndex(n=>n.udccode==self.tree3),1);
				};
			},
			getShowCont(){//获取树结构
				this.$http.get(process.env.API_ROOT + this.contUrl,{params:{udcTypes:'SHOW_CONT'}})
					.then((response) => {
						if(response.body.success) {
							const obj = response.body.data[0];
							this.showContList1 = obj.SHOW_CONT 
							/*if(this.curMode === 'new'){
								for (var value of this.showContList1) {
									if(value.udccode=='VEHICLE_ACCOUNT'){
										this.tree1 = 'VEHICLE_ACCOUNT'
									}
									if(value.udccode=='PLATE_NUMBER'){
										this.tree2 = 'PLATE_NUMBER'
									}
									if(value.udccode=='OWNER_NAME'){
										this.tree3 = 'OWNER_NAME'
									}
								}
							}*/
							
						} else {					
							this.$refs.modal2.open();
							this.showWithdraw = false;
							this.tipContent = response.body.message
						}
					}, (response) => {
						this.$refs.modal2.open();
						this.showWithdraw = false;
						this.tipContent = response.body.message
					})
			},
			async postNewSave(param){//新建保存 
				await this.saveRatio()
				let orgPId = this.isAdmin==9?this.selectCustomerId:this.curParentId  
				this.loadingstatus = true;// this.postUrl+'?parentCustomerId='+this.selectCustomerId
				this.$http.post(process.env.API_ROOT + this.postUrl+'?parentCustomerId='+ orgPId,param)
					.then((response) => {
						if(response.body.success) {
							this.showWithdraw = false;//不显示取消按钮
							this.tipContent = OPERATE_SUCCESS
							this.$refs.modal2.open();
							this.toRefresh = true;//该刷新表格
							this.timeToBack = true;//该返回一览页面
							//this.$store.dispatch('setuserimg',this.logoImg);
						} else {
							this.$refs.modal2.open();
							this.showWithdraw = false;//不显示取消按钮
							this.tipContent = response.body.message
						}
						this.loadingstatus = false;
					}, (response) => {
						this.$refs.modal2.open();
						this.showWithdraw = false;//不显示取消按钮
						this.loadingstatus = false;
						this.tipContent = response.body.message
					})
			},
			async putEditSave(param){//编辑保存
				await this.saveRatio()
				this.loadingstatus = true;  
				let list = ''
				if(this.funcList.length!=0){
					let tmp = (this.getFuncSelectedLeafNodes()) 
					list = tmp.join(',') //编辑分支组织机构时传功能树id
					if(list == ''){
						this.$refs.modal2.open();
						this.showWithdraw = false;
						this.tipContent = '请设置功能树'
						return
					}
				} 
				this.$http.put(process.env.API_ROOT + this.putUrl + '?resourceList=' + list,this.param)
				.then((response) => {
						if(response.body.success) {
							this.$refs.modal2.open();
							this.showWithdraw = false;
							this.tipContent = OPERATE_SUCCESS
							this.timeToBack = true;
							this.toRefresh = true;//该刷新表格
							if (this.param.customerId==this.$store.state.user.groupid){
								this.$store.dispatch('setuserimg',this.logoImg);
							}
						} else {
							this.$refs.modal2.open();
							this.showWithdraw = false;
							this.tipContent = response.body.message
						}
						this.loadingstatus = false;
					}, (response) => {
						this.$refs.modal2.open();
						this.showWithdraw = false;
						this.loadingstatus = false;
						this.tipContent = response.body.message
					})
			},
			setFormInfo(){//根据编辑、详情和新建模式来设置form内容
				if(this.curMode==="detail" || this.curMode ==="edit"){	
					this.orgName = this.orgInfo.customerName;	
					this.orgStatus = this.orgInfo.isenable;
					this.orderNo = this.orgInfo.orderno;
					this.orgPerson = this.orgInfo.linkman;
					this.orgTel = this.orgInfo.telephone;
					this.orgAdd = this.orgInfo.address;
					this.orgMail = this.orgInfo.adminMail;
					this.maxNum = this.orgInfo.maxMount || 0;
					this.tree1 = this.orgInfo.showCont1;
					this.tree2 = this.orgInfo.showCont2;
					this.tree3 = this.orgInfo.showCont3;
					this.note = this.orgInfo.memo;
					this.logoSrc = this.orgInfo.logo=='' ? '' : process.env.PIC_BASE_PATH + this.orgInfo.logo;
					this.logoImg = this.orgInfo.logo;
					this.createPerson = this.orgInfo. createName;
					this.createTime = this.orgInfo.createTime;
					this.changePerson = this.orgInfo.updateName;
					this.changeTime = this.orgInfo.updateTime;
					this.isShowTest = this.orgInfo.isShowTest ==1?true:false;
					this.shortName = this.orgInfo.shortName;
					if(this.curMode == 'edit'){
						this.licenceId = this.orgInfo.licenceId;
						let vObj = this.orgInfo.versionInfo
						this.carMaxMount = vObj.residuemaxMount;
						this.carMinMount = vObj.minMount
						if(vObj.versionMap != null){
							this.versionArr = vObj.versionMap.version
						}
					} 
					if(this.curMode === "detail"){
					/*	this.$nextTick(function(){
							const subPage = document.getElementById('subPage');
							const oInput = subPage.getElementsByTagName('input');
							const oTextarea = subPage.getElementsByTagName('textarea');
							const oSelect = subPage.getElementsByTagName('select');					
							const inputArr = Array.from(oInput);
							const textareaArr = Array.from(oTextarea);
							const selectArr = Array.from(oSelect);
							inputArr.map((n)=>{
								n.setAttribute('disabled','disabled')
							});
							textareaArr.map((n)=>{
								n.setAttribute('disabled','disabled')
							});
							selectArr.map((n)=>{
								n.setAttribute('disabled','disabled')
							});
							
						})*/
						this.btnValue = "关闭"
					}
					
				}else{ 
					this.$nextTick(function(){
						const hideDiv = document.getElementById('hideWhenNew');
						hideDiv.style.display = 'none';
					})
				}
			},	
			onSave(){//点击 ‘保存’/'关闭'按钮
				if(this.btnValue==="保存"){ 
					this.param = {
						customerId:this.orgInfo.customerId,
						customerName : this.orgName,
						isenable : this.orgStatus,
						orderno : this.orderNo,
						linkman : this.orgPerson || '',
						telephone : this.orgTel || '',
						address : this.orgAdd || '',
						adminMail : this.orgMail,
						maxMount : this.maxNum || '',
						showCont1 : this.tree1,
						showCont2 : this.tree2 || '',
						showCont3 : this.tree3 || '',
						memo : this.note || '',
						logo:this.logoImg || '',
						isShowTest:this.isShowTest?1:0,
						account:this.account + '@' + this.shortName,
						shortName:this.shortName,
						password:this.password
					}  
					if(this.curMode === 'new'){
						delete this.param.customerId 
						if(this.selectCustomerId == 1 || this.curParentId == 1){
							this.param.licenceId = this.licenceId
						}else{
							this.param.licenceId = ''
						}
						let list = ''
						if(this.funcList.length!=0){
							let tmp = (this.getFuncSelectedLeafNodes())
							list = tmp.join(',') 
							if(list == ''){
								this.$refs.modal2.open();
								this.showWithdraw = false;
								this.tipContent = '功能树数据为空'
								return
							}
						}else{
							if(this.isAdmin == 9 && this.selectCustomerId != 1 || this.isAdmin != 9 && this.curParentId != 1){
								this.$refs.modal2.open();
								this.showWithdraw = false;
								this.tipContent = '请设置功能树'
								return
							} 
						}
						this.param.resourceList = list //新建分支组织机构时传功能树id
						this.$refs.modal2.open();
						this.showWithdraw = true;
						this.tipContent = ADD_ENSURE.replace('{1}','组织机构')	
					}else if(this.curMode === 'edit'){	
						delete this.param.password
						delete this.param.account 
						this.param.licenceId = ''
						this.$refs.modal2.open();
						this.showWithdraw = true;
						this.tipContent = EDIT_ENSURE.replace('{1}','组织机构')
					}else{
						return false;
					}
				}else{
					this.$emit('goBackPage');
				}
			},
			confirmSubBtn(){//弹框点击确认按钮
				if(this.showWithdraw){//---有取消按钮时 
					if(this.curMode==='new'){  
						this.postNewSave(this.param)	
					}else if(this.curMode === 'edit'){ 
						this.putEditSave(this.param)
					}
				}
				if(this.toRefresh){//---需要刷新表格数据时
					this.$emit('timeToRefresh')
				}
				this.showWithdraw = false;
				this.closeSubTip();
			},
			withdrawSubBtn(){//点击取消按钮
				this.closeSubTip();
			}, 
			closeSubTip() {//关闭弹框
				this.$refs.modal2.close();	
				if(this.timeToBack){//--保存完成1，点确认按钮关闭弹框，2，关闭subpage组件需要返回一览页面
					this.$emit('goBackPage');
				}
			},
			//以下跟上传图片有关 
			imageuploaded(res){
				if(res.success){
					this.logoImg = res.data//传给后台的信息
					this.logoSrc = process.env.PIC_BASE_PATH + res.data;
					this.$emit('adjustTip','图片上传成功')
				}else{
					this.tipContent = INFO_EXCEPTION.replace('{1}','上传图片');
					this.$refs.modal2.open();
					this.showWithdraw = false;				
				}
			},
			//在新建状态下 超管状态下 获取下拉
			getCustomerTree(){
				if(this.curMode!='new')return;
				if(this.isAdmin!=9)return; 
				this.$http.get(process.env.API_ROOT + '/account/customer-tree')
				.then(res => {
					if(res.data.success){
						const that = this
						this.superAdminCustomerList = res.body.data; 
						this.superAdminCustomerList.forEach(function(item){
							item.text = item.name;
							item.selected = item.id == that.selectCustomerId
						}) 
					}else{
						this.$refs.modal2.open();
						this.showWithdraw = false;//不显示取消按钮
						this.tipContent = res.body.message;
					}
				}, res => {
					this.$refs.modal2.open();
					this.showWithdraw = false;//不显示取消按钮
					this.tipContent = res.data.message;
				}) 
			}
		}
	};
</script>
<style scoped>
    .btn{cursor:pointer;}
    .upload-pic{
    	width:100px;
    	height:100px;
    	text-align:center;
    	font-size:16px;
    	line-height: 100px;
    	color:#46AC89; 
    	background-image:url(../../../assets/project/images/upload_pic.png);
    	background-size:contain;
    	background-position:center;
    	cursor:pointer;
    }
</style>


// WEBPACK FOOTER //
// PageOrganiseEdit.vue?1dc4743e